<template>
    <a-modal :visible="visible"
             title="导入"
             width="800px"
             :mask="true"
             @cancel="close"
             :bodyStyle="{'height':'600px'}"
             class="modal-content"
             :maskClosable="false"
             :centered="true"
             :keyboard="false">
        <div slot="footer">
            <a-button @click="templateDownload('条码校验模板')" :disabled="loading" style="float: left">模版下载</a-button>
            <a-space size="small">
                <a-button @click="close" :disabled="loading">关闭</a-button>
                <a-button @click="handleUpload" type="primary" :disabled="loading" v-if="state===0">导入</a-button>
            </a-space>
        </div>
        <a-result v-show="showResult" :title="uploadTitle()">
            <template #icon>
                <a-icon type="loading" slot="icon" v-if="state===0" :style="'color: '+params.primaryColor"/>
                <a-icon type="check-circle" slot="icon" v-else-if="state===1" :style="'color: '+params.primaryColor"/>
                <a-icon type="close-circle" slot="icon" v-else-if="state===-1" :style="'color: '+params.warnColor"/>
            </template>
            <div class="desc" v-if="state ===0 || state ===1">
                <p style="font-size: 16px;"><strong>共{{ sumCount }}条记录</strong></p>
                <p>
                    <a-icon type="check-circle" :style="{color:'green'}"/>
                    <span style="margin-left: 4px;">已成功处理{{ successCount }}条</span>
                </p>
                <p>
                    <a-icon type="close-circle" :style="{color:'red'}"/>
                    <span style="margin-left: 4px;">未成功处理{{ failCount }}条</span>
                    <a style="margin-left: 16px" v-if="state===1" @click="handleDownResult">查看结果</a>
                </p>
            </div>
        </a-result>

        <div v-show="!showResult">
            <a-card size="small" title="导入文件" :bordered="false" style="min-height: 150px">
                <a-upload list-type="picture" :action="fileUpload" :headers="headers" accept=".xls,.xlsx" @change="uploadStateChange" :file-list="fileList">
                    <a-button v-if="fileList.length ===0">
                        <a-icon type="upload"/>
                        浏览文件
                    </a-button>
                </a-upload>
            </a-card>
            <a-card size="small" title="导入模式" :bordered="false">
                <a-form-model ref="form" :model="form" :rules="rules" class="vertical-form">
                    <a-form-model-item label="导入方式" prop="importType">
                        <a-select v-model="form.importType">
                            <a-select-option key="1">追加</a-select-option>
                            <a-select-option key="2">清除原有数据</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-form-model>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
import {ImportModalMixin} from "@/utils/ImportModalMixin";
import {mixin} from "@/utils/mixin";

export default {
    name: "InUploadBarcodeImportModal",
    mixins: [ImportModalMixin, mixin],
    props: {
        relationId: {
            type: String
        }
    },
    data: function () {
        return {
            optName: "条码校验导入",
            form: {
                importType: "1",
                priceType: "1",
            },
            importKey: "WarehouseInUploadBarcodeExcelInput",
            url: {
                exportTemplate: "/sys/excelTemplate/template?importKey=WarehouseInUploadBarcodeExcelInput",
            }
        }
    },
    methods: {
        setParam: function (param) {
            param.importType = this.form.importType
            param.relationId = this.relationId
        }
    },
}
</script>

<style scoped>

</style>
